module.exports = __webpack_public_path__ + "img/frame (80).0094deb6.jpg";